export const translations = {
    es: {
        home: {
            title: 'ChessDrez',
            subtitle: 'Domina cada movimiento del tablero',
            play: 'Jugar',
            puzzles: 'Puzzles',
            analysis: 'Análisis',
            openings: 'Aperturas',
            learn: 'Aprender',
            profile: 'Perfil',
            settings: 'Ajustes',
            logout: 'Cerrar Sesión',
            startTraining: 'Comenzar Entrenamiento',
            trainingPlan: 'Plan de Entrenamiento Diario',
            trainingDesc: 'Personaliza tu aprendizaje basándote en tus debilidades tácticas detectadas.',
            playDesc: 'Juega contra la IA ajustada.',
            puzzlesDesc: 'Resuelve acertijos tácticos.',
            analysisDesc: 'Analiza tus partidas con motor.',
            openingsDesc: 'Estudia aperturas y variantes.',
            learnDesc: 'Cursos interactivos paso a paso.',
            settingsDesc: 'Personaliza tu experiencia.'
        },
        settings: {
            title: 'Ajustes',
            interface: 'Interfaz y Sonido',
            sound: 'Efectos de sonido',
            dark: 'Modo Oscuro',
            animations: 'Animaciones de piezas',
            privacy: 'Privacidad y Cuenta',
            notifications: 'Notificaciones',
            publicProfile: 'Perfil público',
            language: 'Idioma',
            pieceStyle: 'Estilo de Piezas',
            boardTheme: 'Tema del Tablero',
            themes: {
                tecnico: 'Técnico',
                clasico: 'Clásico',
                azul: 'Azul',
                madera: 'Madera',
                arena: 'Arena',
                cyber: 'Cyber'
            }
        },
        play: {
            opening: 'Apertura',
            midgame: 'Medio juego',
            surrender: 'Rendirse',
            newGame: 'Nueva Partida',
            config: 'Configuración',
            difficulty: 'Dificultad',
            commentary: {
                blunder: '¡Error grave! La posición ha empeorado drásticamente.',
                mistake: 'Un error. Había mejores opciones.',
                inaccuracy: 'Imprecisión. Pierdes un poco de ventaja.',
                good: 'Buena jugada.',
                excellent: '¡Excelente movimiento!',
                best: '¡La mejor jugada!',
                book: 'Movimiento de libro.',
                mate: '¡Mate a la vista!',
                advantageWhite: 'Ventaja para las Blancas.',
                advantageBlack: 'Ventaja para las Negras.',
                equal: 'Posición igualada.',
            },
            aiLevel: 'Nivel de IA',
            competitive: 'Competitivo',
            approxElo: 'ELO Aprox:',
            timeControl: 'Control de Tiempo',
            playAs: 'Jugar como',
            white: 'Blancas',
            black: 'Negras',
            random: 'Azar',
            start: 'Comenzar Partida',
            noLimit: 'Sin Límite'
        },
        analysis: {
            title: 'Análisis de Partidas',
            engineOn: 'Encender Motor',
            engineOff: 'Apagar Motor',
            bestMove: 'Mejor Jugada',
            depth: 'Profundidad',
            classification: 'Clasificación',
            fen: 'FEN actual',
            turn: 'Turno',
            whites: 'Blancas',
            blacks: 'Negras',
            move: 'Movimiento',
            loadFen: 'Cargar FEN',
            invalidFen: 'FEN inválido',
            suggest: 'Sugerencia'
        },
        puzzles: {
            title: 'Puzzles Tácticos',
            hint: 'Pista',
            retry: 'Reintentar',
            skip: 'Saltar',
            next: 'Siguiente Puzzle',
            correct: '¡Correcto!',
            incorrect: 'Incorrecto. Inténtalo de nuevo.',
            nextMove: '¡Bien! Siguiente movimiento...',
            yourTurn: 'Tu turno — ¡Encuentra la jugada!',
            cpuMoving: 'CPU moviendo...',
            solved: 'Resuelto',
            failed: 'Fallado',
            streak: 'Racha',
            beginner: 'Principiante',
            intermediate: 'Intermedio',
            advanced: 'Avanzado',
            info: 'Información del puzzle',
            categories: 'Categorías'
        },
        openings: {
            title: 'Aperturas',
            theory: 'Teoría',
            training: 'Entrenamiento',
            exercises: 'Ejercicios',
            search: 'Buscar apertura...',
            groups: 'Grupos de Aperturas',
            selectTheory: 'Selecciona una apertura para estudiar su teoría.',
            selectTraining: 'Selecciona una apertura para poner a prueba tu memoria.',
            selectExercise: 'Selecciona un ejercicio táctico de apertura.',
            outOfBook: 'Fuera de libro. ¡Buen trabajo!',
            inBook: 'Movimiento de libro. Sigue así.',
            incorrect: 'Movimiento incorrecto según el libro.',
            yourTurn: 'Tu turno',
            cpuTurn: 'Turno de la IA',
            reintentar: 'Reintentar',
            playAs: 'Jugar como'
        },
        learn: {
            title: 'Aprender',
            fundamentals: 'Fundamentos',
            tactics: 'Táctica',
            endgames: 'Finales',
            classics: 'Partidas Clásicas',
            lessons: 'lecciones',
            steps: 'pasos',
            step: 'Paso',
            of: 'de',
            resetStep: 'Reiniciar paso',
            comingSoon: 'Próximamente contenido para esta categoría.',
            allLessons: 'Todas las lecciones'
        },
        profile: {
            title: 'Mi Perfil',
            globalRating: 'Rating Global (ELO)',
            tacticalRating: 'Rating Táctico',
            globalDesc: 'Basado en partidas vs CPU y análisis.',
            tacticalDesc: 'Calculado tras resolver puzzles.',
            user: 'Usuario'
        },
        common: {
            back: 'Volver',
            close: 'Cerrar',
            loading: 'Cargando...'
        }
    },
    en: {
        home: {
            title: 'ChessDrez',
            subtitle: 'Master every move on the board',
            play: 'Play',
            puzzles: 'Puzzles',
            analysis: 'Analysis',
            openings: 'Openings',
            learn: 'Learn',
            profile: 'Profile',
            settings: 'Settings',
            logout: 'Logout',
            startTraining: 'Start Training',
            trainingPlan: 'Daily Training Plan',
            trainingDesc: 'Customize your learning based on your detected tactical weaknesses.',
            playDesc: 'Play against the tuned AI.',
            puzzlesDesc: 'Solve tactical puzzles.',
            analysisDesc: 'Analyze your games with engine.',
            openingsDesc: 'Study openings and variations.',
            learnDesc: 'Step-by-step interactive courses.',
            settingsDesc: 'Personalize your experience.'
        },
        settings: {
            title: 'Settings',
            interface: 'Interface & Sound',
            sound: 'Sound Effects',
            dark: 'Dark Mode',
            animations: 'Piece Animations',
            privacy: 'Privacy & Account',
            notifications: 'Notifications',
            publicProfile: 'Public Profile',
            language: 'Language',
            pieceStyle: 'Piece Style',
            boardTheme: 'Board Theme',
            themes: {
                tecnico: 'Technical',
                clasico: 'Classic',
                azul: 'Blue',
                madera: 'Wood',
                arena: 'Sand',
                cyber: 'Cyber'
            }
        },
        play: {
            opening: 'Opening',
            midgame: 'Middlegame',
            surrender: 'Surrender',
            newGame: 'New Game',
            config: 'Configuration',
            difficulty: 'Difficulty',
            commentary: {
                blunder: 'Blunder! The position has worsened drastically.',
                mistake: 'Mistake. There were better options.',
                inaccuracy: 'Inaccuracy. You lost some advantage.',
                good: 'Good move.',
                excellent: 'Excellent move!',
                best: 'The best move!',
                book: 'Book move.',
                mate: 'Mate is coming!',
                advantageWhite: 'Advantage for White.',
                advantageBlack: 'Advantage for Black.',
                equal: 'Equal position.',
            },
            aiLevel: 'AI Level',
            competitive: 'Competitive',
            approxElo: 'Approx ELO:',
            timeControl: 'Time Control',
            playAs: 'Play as',
            white: 'White',
            black: 'Black',
            random: 'Random',
            start: 'Start Game',
            noLimit: 'No Limit'
        },
        analysis: {
            title: 'Game Analysis',
            engineOn: 'Engine On',
            engineOff: 'Engine Off',
            bestMove: 'Best Move',
            depth: 'Depth',
            classification: 'Classification',
            fen: 'Current FEN',
            turn: 'Turn',
            whites: 'Whites',
            blacks: 'Blacks',
            move: 'Move',
            loadFen: 'Load FEN',
            invalidFen: 'Invalid FEN',
            suggest: 'Suggestion'
        },
        puzzles: {
            title: 'Tactical Puzzles',
            hint: 'Hint',
            retry: 'Retry',
            skip: 'Skip',
            next: 'Next Puzzle',
            correct: 'Correct!',
            incorrect: 'Incorrect. Try again.',
            nextMove: 'Good! Next move...',
            yourTurn: 'Your turn — Find the move!',
            cpuMoving: 'CPU moving...',
            solved: 'Solved',
            failed: 'Failed',
            streak: 'Streak',
            beginner: 'Beginner',
            intermediate: 'Intermediate',
            advanced: 'Advanced',
            info: 'Puzzle Information',
            categories: 'Categories'
        },
        openings: {
            title: 'Openings',
            theory: 'Theory',
            training: 'Training',
            exercises: 'Exercises',
            search: 'Search opening...',
            groups: 'Opening Groups',
            selectTheory: 'Select an opening to study its theory.',
            selectTraining: 'Select an opening to test your memory.',
            selectExercise: 'Select an opening tactical exercise.',
            outOfBook: 'Out of book. Good job!',
            inBook: 'Book move. Keep going.',
            incorrect: 'Incorrect move according to the book.',
            yourTurn: 'Your turn',
            cpuTurn: 'AI turn',
            reintentar: 'Retry',
            playAs: 'Play as'
        },
        learn: {
            title: 'Learn',
            fundamentals: 'Fundamentals',
            tactics: 'Tactics',
            endgames: 'Endgames',
            classics: 'Classic Games',
            lessons: 'lessons',
            steps: 'steps',
            step: 'Step',
            of: 'of',
            resetStep: 'Reset step',
            comingSoon: 'More content coming soon for this category.',
            allLessons: 'All lessons'
        },
        profile: {
            title: 'My Profile',
            globalRating: 'Global Rating (ELO)',
            tacticalRating: 'Tactical Rating',
            globalDesc: 'Based on games vs CPU and analysis.',
            tacticalDesc: 'Calculated after solving puzzles.',
            user: 'User'
        },
        common: {
            back: 'Back',
            close: 'Close',
            loading: 'Loading...'
        }
    }
};

export type Language = 'es' | 'en';
export type TranslationKeys = typeof translations.es;
